import React from 'react'

import Layout from '../components/layout'

const TermsPage = () => (
  <Layout>
    <div class="text-content">
      <div class="text-content__inner">
        <div class="content">
          <h2 class="text-content__title">User Terms </h2>
          <p>
            These are the terms and conditions (<strong>「Terms」</strong>)
            which apply to your use of the gini software application (「App」).
            References to the 「App」 include any products and services that may
            be provided to you through the App. By registering for, installing,
            downloading, accessing and/or using the App (or attempting to do
            so), you agree to be bound by these Terms and the documents referred
            to in them. If you do not agree with or do not accept any of these
            Terms, you should not register for, install, download, access or use
            the App. If you have any questions about the App, please contact us
            at <a href="mailto:info@gini.co">info@gini.co</a>.
          </p>
          <ol>
            <li>
               <strong>App Provider</strong>The App is provided by More Champ
              Limited (trading as gini) (「<strong>we</strong>「, 「
              <strong>our</strong>」 or 「<strong>us</strong>「). Our registered
              office is 2/F, Henan Building, 90-92 Jaffe Road, Wan Chai, Hong
              Kong.
            </li>
            <li>
               <strong>Using the App</strong>
              <ol>
                <li>
                  The App is for your personal and non-commercial use only. We
                  grant you a non-transferable, non-exclusive, revocable licence
                  to install, download, access and use the App in accordance
                  with these Terms.
                </li>
                <li>
                   You must keep confidential and not share with any third party
                  your username, password or any other information required for
                  accessing and/or using the App. If you become aware that the
                  confidentiality of such information has been comprised, you
                  must immediately change your password and notify us.
                </li>
                <li>
                   You warrant and represent that you are the owner of and/or
                  have relevant permission from the owner(s) of:
                  <ol>
                    <li>any devices and equipment that you use; and</li>
                    <li>
                       any online accounts (including online banking accounts)
                      to which you may choose to connect via the App,
                    </li>
                  </ol>
                  <li>
                    For the purposes of registering for, installing,
                    downloading, accessing and/or using the App. You accept
                    responsibility in accordance with these Terms whether or not
                    you are the owner of such devices, equipment or online
                    accounts.
                  </li>
                  <li>
                     You must not use the App to engage in any activity which is
                    unlawful, whether in Hong Kong or in any part of the world.
                  </li>
                  <li>
                     Any links, content or information provided to you via the
                    App is for your general information purposes only and do not
                    constitute technical, financial or legal advice or any other
                    type of advice and should not be relied on for any purposes.
                  </li>
                  <li>
                     The App may contain links and/or references to third party
                    websites, content, information, products and/or services (「
                    <strong>Third Party Content</strong>「). Any such links,
                    references and Third Party Content are provided for your
                    convenience only and do not mean that we endorse them. We
                    have no control over such Third Party Content and accept no
                    legal responsibility for them. Your use of such Third Party
                    Content will be subject to the terms and conditions and
                    privacy statements of that third party.
                  </li>
                </li>
              </ol>
            </li>
            <li>
              <strong>Availability</strong>
              <ol>
                <li>
                   The App is provided on an “as is” and “as available” basis.
                  While we try to make sure that the App is accurate, up-to-date
                  and free from viruses, worms, trojan horses, bugs, defects,
                  errors or interruptions, we do not warrant that it will be.
                  Furthermore, to the maximum extent permitted by statute,
                  common law or otherwise, we provide no warranties (express or
                  implied) regarding the fitness for purpose, compatibility or
                  satisfactory quality of the App.
                </li>
                <li>
                   We may change the specifications or manner of use of the App
                  (or any part of it), and suspend or terminate the operation of
                  the App, at any time as we see fit.
                </li>
              </ol>
            </li>
            <li>
              <strong>Liability</strong>
              <ol>
                <li>
                   Our total liability shall not exceed an amount equal to any
                  fees paid by you for installing, downloading, accessing or
                  using the App.
                </li>
                <li>
                   We shall not be liable for any consequential, indirect or
                  special losses. In addition, we shall not be liable for any of
                  the following (whether direct or indirect): loss of profit;
                  loss of data; loss of use; loss of contract; loss of
                  opportunity; loss of savings, discount or rebate (whether
                  actual or anticipated); harm to reputation; loss of goodwill;
                  or any damage or alteration to any devices or equipment that
                  may be used to register for, install, download, access or use
                  the App.
                </li>
                <li>
                   We shall have no liability to you for any breach of these
                  Terms, or any delays or failures in relation to the App, which
                  result from any events or circumstances beyond our reasonable
                  control, including: strikes, lock-outs or other industrial
                  disputes; delays or failures in systems, networks or internet
                  access; flood, fire, explosion or accident; acts of war or
                  legal restrictions.
                </li>
                <li>
                   Notwithstanding any other provision in these Terms, we do not
                  exclude or limit our liability in respect of death or personal
                  injury caused by negligence, fraud or fraudulent
                  misrepresentation, or for any other losses which cannot be
                  excluded or limited by applicable law.
                </li>
              </ol>
            </li>
            <li>
              <strong>Variation</strong>We reserve the right to vary these Terms
              from time to time, due to changes in market conditions affecting
              our business, changes in technology, changes in payment methods,
              changes in relevant laws and regulations or any other changes. Any
              variations may be communicated to you in writing (including by
              email) or otherwise made available via the App or on our website.
              Following any variations to these Terms, by continuing to access
              or use the App, you agree to be bound by such varied Terms.
            </li>
            <li>
               <strong>Security and data protection</strong>
              <ol>
                <li>
                   「<strong>Customer Data</strong>」 means any information or
                  content which you provide to us when accessing or using the
                  App (or for the purpose of accessing or using the App). We
                  will take reasonable steps to ensure that all Customer Data in
                  our possession is kept secure, including maintaining
                  appropriate encryption protection.
                </li>
                <li>
                   By accessing or using the App, you acknowledge and agree that
                  internet transmissions are never completely private or secure
                  and you remain responsible for ensuring that any internet
                  connection that you use for accessing or using the App is
                  secure.
                </li>
                <li>
                   You grant us a royalty-free licence (for the duration of this
                  agreement) to use the Customer Data to the extent necessary to
                  provide our services to you via the App. We may anonymise
                  Customer Data and use such anonymised data to improve or
                  enhance the App (including our products and services).
                  However, we will not provide your personal data to third
                  parties without your consent – please refer our Privacy
                  Statement (available here: 
                  <a href="http://ginidev.greyloud.com/pages/privacy-policy.html">
                    Privacy Statement
                  </a>
                  ) for further provisions that apply to these Terms.
                </li>
                <li>
                   For the avoidance of doubt, in respect of any online accounts
                  (including online banking accounts) to which you may choose to
                  connect via the App, we do not collect store any usernames,
                  passwords or other authentication details for such accounts –
                  such authentication details do not leave the device or
                  equipment on which the App is downloaded, installed or
                  otherwise connected. There may be promotions or offers
                  available to you via the App which, should you wish to accept
                  them, may require us to collect and process personal data from
                  you. For further details, please see our Privacy Statement
                  referred to above.
                </li>
              </ol>
            </li>
            <li>
               <strong>Intellectual property</strong>
              <ol>
                <li>
                   We (or our group of companies or licensors) own all
                  intellectual property rights in relation to the App (including
                  copyright, trade marks, service marks, logos, design rights,
                  rights to inventions, rights to software and source code, and
                  database rights). Nothing in these Terms shall confer on you
                  any licence with respect to such intellectual property rights.
                </li>
                <li>
                   You shall not, and shall not permit third parties, to:
                  <ol>
                    <li>make and/or distribute copies of the App;</li>
                    <li>
                       decompile, reverse engineer or disassemble the App (or
                      attempt to do so); or
                    </li>
                    <li>
                       download‚ reproduce, transfer, publish, redistribute,
                      adapt, create derivative works from, or make extracts of,
                      the App or any content or information within it (or any
                      part of it), other than for your personal‚ non-commercial
                      use.
                    </li>
                  </ol>
                </li>
                <li>
                   You shall indemnify (and keep indemnified) us and our
                  officers, directors, agents, licensors, successors and assigns
                  from against any and all claims, actions, liabilities, losses,
                  damages and expenses (including legal expenses) of any kind
                  which arise out of or in connection with, directly or
                  indirectly, your breach of any of the Terms.
                </li>
              </ol>
            </li>
            <li>
              <strong>Termination</strong>
              <ol>
                <li>
                   We may terminate these Terms and/or prevent or suspend your
                  access to the App (or any part of it), temporarily or
                  permanently and without notice, for any reason (including: if
                  we reasonably believe that: you have not complied with any
                  part of these Terms, any terms or policies to which they refer
                  or any applicable law; or our provision of the App is no
                  longer commercially viable).
                </li>
                <li>
                   You may delete your account with us, in which case these
                  Terms shall also terminate. If you wish to delete your
                  account, please email us at 
                  <a href="mailto:info@gini.co">info@gini.co</a>.
                </li>
                <li>
                   Termination of these Terms for whatever reason shall not
                  affect any of our or your accrued rights and liabilities.
                </li>
              </ol>
            </li>
            <li>
              <strong>General</strong>
              <ol>
                <li>
                  Any words in these Terms that follow 『include』,
                  『includes』, 『including』, ‘in particular’ or any similar
                  words and expressions shall be construed as illustrative only
                  and shall not limit the sense of any word, phrase, term,
                  definition or description preceding those words.
                </li>
                <li>
                   If any provision in these Terms is determined to be illegal,
                  invalid or otherwise unenforceable then, to the extent of such
                  illegality, invalidity or unenforceability, such provision
                  shall be severed from these Terms and the remaining terms and
                  conditions shall survive in full force and effect.
                </li>
                <li>
                   If we fail at any time to insist upon strict performance of
                  any of your obligations under these Terms, or if we fail to
                  exercise any of our rights or remedies to which we are
                  entitled under these Terms, it shall not constitute a waiver
                  of such rights or remedies and shall not relieve you from
                  compliance with such obligations.
                </li>
                <li>
                   These Terms set out the whole of our agreement relating to
                  your installing, downloading, accessing and/or using the App.
                </li>
                <li>
                   No one other than us or you has any right to enforce any
                  provision term of this contract, whether under the Contracts
                  (Rights of Third Parties) Ordinance or otherwise.
                </li>
              </ol>
            </li>
            <li>
               <strong>Applicable law and jurisdiction</strong>These Terms shall
              be governed by the laws of the Hong Kong Special Administrative
              Region of the People's Republic of China (「
              <strong>Hong Kong</strong>「) and the parties shall irrevocably
              submit to the exclusive jurisdiction of the courts of Hong Kong.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </Layout>
)

export default TermsPage
